import React from "react";

export default {
  id: "myJLMembership",
  type: "form",
  form: {
    subject: "My_JL_Voucher_query",
    fields: ["FULL_NAME", "POSTCODE", "EMAIL", "PHONE_NUMBER", "MY_JL_MEM_NUMBER", "IMAGE_UPLOAD", "DESCRIPTION"],
    imageMessage: "We accept jpg, jpeg, png or gif",
    message: (
      <p>
        Your membership card is stored online, so there’s no need to carry a plastic card. You can access it from the
        John Lewis & Partners app, and by signing in to{" "}
        <a href="https://account.johnlewis.com/my-jl/details">My Account</a> on our website. You can also update
        information like your personal details.
      </p>
    ),
  },
};
